import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';
import Icon from '../Icon';
import PlainButton from '../PlainButton';
import { orange } from '../tokens';

// Floating action button for phone layouts: a fixed 56px orange button in
// the bottom-right corner (z 100), above the home indicator on notched
// phones. `bottomOffset` lifts it clear of anything pinned to the bottom
// edge (e.g. the SaveBar). Always give it a `label`: it is icon-only.

const Button = styled(PlainButton)`
  position: fixed;
  right: 20px;
  width: 56px;
  height: 56px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 16px;
  color: #fff;
  background: linear-gradient(
      135deg,
      rgba(255, 255, 255, 0.16),
      rgba(255, 255, 255, 0)
    ),
    ${orange(1)};
  box-shadow: 0 8px 24px ${orange(0.4)};
  bottom: calc(${(p) => p.$bottom}px + env(safe-area-inset-bottom, 0px));
  z-index: 100;
  transition: bottom 200ms cubic-bezier(0.2, 0.8, 0.2, 1), transform 120ms ease;

  &:active {
    transform: scale(0.94);
  }

  &:focus-visible {
    box-shadow: 0 8px 24px ${orange(0.4)}, 0 0 0 3px ${orange(0.45)};
  }
`;

const Fab = ({ label, icon, onClick, bottomOffset, hidden }) => {
  if (hidden) return null;
  return (
    <Button
      aria-label={label}
      title={label}
      onClick={onClick}
      $bottom={bottomOffset}
    >
      <Icon name={icon} size={24} color="currentColor" />
    </Button>
  );
};

Fab.propTypes = {
  label: PropTypes.string.isRequired,
  icon: PropTypes.string,
  onClick: PropTypes.func,
  bottomOffset: PropTypes.number,
  hidden: PropTypes.bool,
};

Fab.defaultProps = {
  icon: 'plus',
  onClick: undefined,
  bottomOffset: 24,
  hidden: false,
};

export default Fab;
